module.exports = __webpack_public_path__ + "img/factor_b.417b8d8b.svg";